import {
    FB_LOGOUT,
    FB_LOGIN,
    FB_LOGIN_FAILURE,
    FB_LOGIN_SUCCESS,
    GET_PAGES,
    GET_PAGES_SUCCESS,
    GET_PAGES_FAILURE,
    PARSE_XFBML,
    PARSE_XFBML_SUCCESS,
    PARSE_XFBML_FAILURE,
    LOAD_FACEBOOK_SDK,
    LOAD_FACEBOOK_SDK_SUCCESS,
    LOAD_FACEBOOK_SDK_FAILURE,
    CONNECT_IG_BUSINESS_ACCOUNT,
    CONNECT_IG_BUSINESS_ACCOUNT_SUCCESS,
    CONNECT_IG_BUSINESS_ACCOUNT_FAILURE,
    GET_IG_BUSINESS_ACCOUNTS,
    GET_IG_BUSINESS_ACCOUNTS_SUCCESS,
    GET_IG_BUSINESS_ACCOUNTS_FAILURE,
    DISCONNECT_IG_BUSINESS_ACCOUNT,
    DISCONNECT_IG_BUSINESS_ACCOUNT_SUCCESS,
    DISCONNECT_IG_BUSINESS_ACCOUNT_FAILURE,
    CLEAR_ERRORS,
} from "./actions";

const initialState = {
    accessToken: null,
    userName: null,
    userId: null,
    userPicture: null,
    pages: [],
    selectedPageId: null,
    isFetchingPages: false,
    isLoggingIn: false,
    loginError: null,
    isParsingXfbml: false,
    loadedFacebookSDK: false,
    isLoadingFacebookSDK: false,
    errorParsingXfbml: null,
    errorFetchingPages: null,
    errorLoadingFacebookSDK: null,
    errorConnectingIgBusinessAccount: null,
    errorDisconnectingIgBusinessAccount: null,
    errorGettingIgBusinessAccount: null,
};

export default function (state = initialState, action) {

    const {payload, type} = action;

    switch (type) {

        case CLEAR_ERRORS: {
            return {
                ...state,
                loginError: null,
                errorParsingXfbml: null,
                errorFetchingPages: null,
                errorLoadingFacebookSDK: null,
                errorConnectingIgBusinessAccount: null,
                errorDisconnectingIgBusinessAccount: null,
                errorGettingIgBusinessAccount: null,
            };
        }

        case FB_LOGOUT: {
            return {
                ...state,
                ...initialState,
            };
        }

        case FB_LOGIN: {
            return {
                ...state,
                isLoggingIn: true,
                loginError: null,
            };
        }

        case FB_LOGIN_SUCCESS: {
            return {
                ...state,
                accessToken: payload.accessToken,
                userName: payload.userName,
                userId: payload.userId,
                userPicture: payload.userPicture,
                isLoggingIn: false,
                loginError: null,
            };
        }

        case FB_LOGIN_FAILURE: {
            return {
                ...state,
                isLoggingIn: false,
                loginError: payload.error,
            };
        }

        case GET_PAGES: {
            return {
                ...state,
                isFetchingPages: true,
                errorFetchingPages: null,
            };
        }

        case GET_PAGES_SUCCESS: {
            return {
                ...state,
                pages: payload.pages,
                isFetchingPages: false,
                errorFetchingPages: null,
            };
        }

        case GET_PAGES_FAILURE: {
            return {
                ...state,
                isFetchingPages: false,
                errorFetchingPages: payload.error,
            };
        }

        case PARSE_XFBML: {
            return {
                ...state,
                isParsingXfbml: true,
                errorParsingXfbml: null,
            };
        }

        case PARSE_XFBML_SUCCESS: {
            return {
                ...state,
                isParsingXfbml: false,
                errorParsingXfbml: null,
            };
        }

        case PARSE_XFBML_FAILURE: {
            return {
                ...state,
                isParsingXfbml: false,
                errorParsingXfbml: payload.error,
            };
        }

        case LOAD_FACEBOOK_SDK: {
            return {
                ...state,
                isLoadingFacebookSDK: true,
                errorLoadingFacebookSDK: null,
            };
        }

        case LOAD_FACEBOOK_SDK_SUCCESS: {
            return {
                ...state,
                isLoadingFacebookSDK: false,
                loadedFacebookSDK: true,
                errorLoadingFacebookSDK: null,
            };
        }

        case LOAD_FACEBOOK_SDK_FAILURE: {
            return {
                ...state,
                isLoadingFacebookSDK: false,
                loadedFacebookSDK: false,
                errorLoadingFacebookSDK: payload.error,
            };
        }

        case CONNECT_IG_BUSINESS_ACCOUNT: {
            return {
                ...state,
                isConnectingIgBusinessAccount: true,
                errorConnectingIgBusinessAccount: null,
            };
        }

        case CONNECT_IG_BUSINESS_ACCOUNT_SUCCESS: {
            const {organizationId, igAccount} = payload;
            return {
                ...state,
                [organizationId]: {
                    igAccounts: [igAccount],
                },
                isConnectingIgBusinessAccount: false,
            };
        }

        case CONNECT_IG_BUSINESS_ACCOUNT_FAILURE: {
            return {
                ...state,
                isConnectingIgBusinessAccount: false,
                errorConnectingIgBusinessAccount: payload.error,
            };
        }

        case GET_IG_BUSINESS_ACCOUNTS: {
            return {
                ...state,
                isGettingIgBusinessAccount: true,
                errorGettingIgBusinessAccount: null,
            };
        }

        case GET_IG_BUSINESS_ACCOUNTS_SUCCESS: {
            const {organizationId, igAccounts} = payload;
            return {
                ...state,
                [organizationId]: {
                    igAccounts,
                },
                isGettingIgBusinessAccount: false,
            };
        }

        case GET_IG_BUSINESS_ACCOUNTS_FAILURE: {
            return {
                ...state,
                isGettingIgBusinessAccount: false,
                errorGettingIgBusinessAccount: payload.error,
            };
        }

        case DISCONNECT_IG_BUSINESS_ACCOUNT: {
            return {
                ...state,
                isDisconnectingIgBusinessAccount: true,
                errorDisconnectingIgBusinessAccount: null,
            };
        }

        case DISCONNECT_IG_BUSINESS_ACCOUNT_SUCCESS: {
            return {
                ...state,
                isDisconnectingIgBusinessAccount: false,
            };
        }

        case DISCONNECT_IG_BUSINESS_ACCOUNT_FAILURE: {
            return {
                ...state,
                isDisconnectingIgBusinessAccount: false,
                errorDisconnectingIgBusinessAccount: payload.error,
            };
        }

        default: {
            return state;
        }
    }
}